function canSeeWhitelists(user) {
  return !!(user.isAdmin || user.isPlaceAdmin || user.isWhitelistManager)
}

export function landingForUser(user) {
  const u = user || {}
  if (u.isAdmin) return { path: '/sessions' }
  if (u.canSeeJurmalaDayPasses) return { path: '/v3/jurmala', external: true }
  if (u.hasOperatorRole) return { path: '/places' }
  if (canSeeWhitelists(u)) return { path: '/v3/whitelists', external: true }
  return { path: '/fleets' }
}

export function legacyHomeLandingForUser(user) {
  return canSeeWhitelists(user || {})
    ? { path: '/v3/whitelists', external: true }
    : { path: '/fleets' }
}
